<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1256.8 345"
    class="debtia-logo"
  >
    <path
      class="debtia-logo-dark"
      d="M199.3,15L250,0v338.9h-50.8v-33.8c-19.1,26.6-46.5,40-82.3,40s-59.9-12-82.7-36C11.4,285,0,255.8,0,221.4s11.4-64.1,34.3-87.9c22.9-23.8,50.4-35.7,82.7-35.7s63.1,13.2,82.3,39.5V15ZM71.9,275.2c14.1,14.3,31.8,21.4,53.1,21.4s39-7.1,53.1-21.4c14.1-14.3,21.2-32.2,21.2-53.8s-7.1-39.6-21.2-53.8c-14.1-14.3-31.8-21.4-53.1-21.4s-39,7.1-53.1,21.4c-14.1,14.3-21.2,32.2-21.2,53.8s7.1,39.6,21.2,53.8Z"
    />
    <path
      class="debtia-logo-dark"
      d="M321,243c3.8,17.9,12.4,31.6,25.9,41.1,13.5,9.6,29.9,14.3,49.4,14.3s47.2-9.7,60.6-29.1l41.8,24.4c-23.2,34.2-57.5,51.2-102.9,51.2s-69.1-11.7-92.6-35c-23.5-23.3-35.3-52.9-35.3-88.6s11.6-64.5,34.8-88.1c23.2-23.7,52.9-35.5,89.3-35.5s62.7,12.1,84.8,36.2c22.1,24.1,33.1,53.4,33.1,87.9s-.6,12.4-1.9,21.2h-187.1ZM320.5,201.6h138.2c-3.5-19.1-11.4-33.5-23.7-43.2-12.4-9.7-26.9-14.6-43.5-14.6s-34.5,5.2-47,15.5c-12.5,10.3-20.5,24.4-24,42.3Z"
    />
    <path
      class="debtia-logo-dark"
      d="M920.7,152.7h-58.3v112.8c0,9.7,2.2,16.7,6.6,20.9,4.4,4.2,10.9,6.6,19.5,7.1,8.6.5,19.3.4,32.2-.2v45.6c-38.9,4.7-66.7,1.3-83.7-10.1-16.9-11.4-25.4-32.5-25.4-63.2v-112.8h-43.2v-48.9h43.2V15l50.8-15v103.9h58.3v48.9Z"
    />
    <rect
      class="debtia-logo-accent"
      x="938.6"
      y="103.9"
      width="50.8"
      height="235"
    />
    <path
      class="debtia-logo-accent"
      d="M1206,103.9l50.8,15v220h-50.8v-33.8c-19.1,26.6-46.5,40-82.3,40s-59.9-12-82.7-36c-22.9-24-34.3-53.2-34.3-87.7s11.4-64.1,34.3-87.9c22.9-23.8,50.4-35.7,82.7-35.7s63.1,13.2,82.3,39.5v-33.4ZM1078.7,275.2c14.1,14.3,31.8,21.4,53.1,21.4s39-7.1,53.1-21.4c14.1-14.3,21.2-32.2,21.2-53.8s-7.1-39.6-21.2-53.8c-14.1-14.3-31.8-21.4-53.1-21.4s-39,7.1-53.1,21.4c-14.1,14.3-21.2,32.2-21.2,53.8s7.1,39.6,21.2,53.8Z"
    />
    <polygon
      class="debtia-logo-accent"
      points="989.4 65.8 989.4 15 938.6 0 938.6 51 989.4 65.8"
    />
    <path
      class="debtia-logo-dark"
      d="M742.1,133.5c-22.9-23.8-50.5-35.7-82.7-35.7s-63.1,13.2-82.3,39.5V15L526.4,0v338.9h50.8v-33.8c19.1,26.6,46.5,40,82.3,40s59.8-12,82.7-36c22.9-24,34.3-53.2,34.3-87.7s-11.4-64.1-34.3-87.9ZM704.5,275.2c-14.1,14.3-31.8,21.4-53.1,21.4s-39-7.1-53.1-21.4c-14.1-14.3-21.2-32.2-21.2-53.8s7.1-39.6,21.2-53.8c14.1-14.3,31.8-21.4,53.1-21.4s39,7.1,53.1,21.4c14.1,14.3,21.2,32.2,21.2,53.8s-7.1,39.6-21.2,53.8Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'LogoFull',
}
</script>
